"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PinSolid: function() {
        return PinSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const PinSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M15.8163 2L7.64922 2C7.43377 2 7.23987 2.08784 7.099 2.2287C6.95813 2.36957 6.8703 2.56348 6.8703 2.77892L6.87195 8.12034C6.64656 8.29933 6.43277 8.49323 6.22893 8.69708C5.0158 9.91021 4.20207 11.5227 4.00486 13.3176C3.95348 13.7766 4.31642 14.1794 4.77881 14.181L10.8014 14.181L10.7981 21.3173C10.7978 21.4045 10.8283 21.489 10.8842 21.5559L11.4444 22.2288C11.5853 22.3995 11.8421 22.4078 11.9963 22.2536C12.0046 22.2454 12.0128 22.2371 12.0195 22.2271L12.5796 21.5543C12.636 21.488 12.6658 21.4018 12.6658 21.3156V14.176L18.6884 14.176C18.9038 14.176 19.0977 14.0882 19.2386 13.9473C19.3993 13.7866 19.4888 13.5579 19.4623 13.3126C19.2303 11.2145 18.1597 9.36827 16.5919 8.11537L16.5919 2.77561C16.5936 2.34969 16.2455 2.00166 15.8163 2Z",
        fill: "currentColor"
    })
}), "PinSolid");
const _default = PinSolid;
